import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { useToastContext } from '../../../../../common/components/ui/toast/toast.context';
import { sendFile } from '../../../../../common/services/hold-document';

interface FileInputProps {
  onChange?: (file: string) => void;
  pathToUpload: string;
  resourceId?: string;
  resource?: string;
  name?: string;
  currentPath: string[];
}

export const FileUploadIndicators = forwardRef<HTMLInputElement, FileInputProps>(
  ({ onChange, pathToUpload, name, currentPath }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [pathsList, setPathsList] = useState<string[]>(currentPath);
    const { notifySuccess, notifyError } = useToastContext();

    useImperativeHandle(ref, () => inputRef.current!);

    const triggerFileSelect = () => inputRef.current?.click();

    useEffect(() => {
      setPathsList(currentPath);
    }, [currentPath]);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      const uploadedFiles: string[] = [];
      if (files) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const result = await handleSendFile(file);
          if (result) {
            uploadedFiles.push(result);
            if (onChange) {
              onChange(result);
            }
          }
        }
      }
    }

    async function handleSendFile(file: File): Promise<string | null> {
      try {
        const prefix = pathToUpload;
        const data = { prefix, file };

        if (name) {
          Object.assign(data, { name });
        }

        const sendFileResponse = await sendFile(data);

        if (!sendFileResponse.ok) {
          throw new Error(sendFileResponse.message || 'Erro ao enviar arquivo');
        }

        const [{ key }] = sendFileResponse.data;
        setPathsList(prevPaths => [...prevPaths, key]);

        notifySuccess(`${file.name} enviado com sucesso`);
        return key;
      } catch (error) {
        notifyError(`Erro ao enviar o arquivo ${file.name}: ${error}`);
        return null;
      }
    }

    return (
      <div>
        <div className="custom-file-input">
          <button type="button" className="m-2 bg-redPrimary text-white" onClick={triggerFileSelect}>Enviar PDF</button>
        </div>
        <input
          type="file"
          accept="*/*"
          ref={inputRef}
          onChange={handleFileChange}
          className="hidden"
          multiple
        />
        <div>
          {pathsList.map((path, index) => (
            <span key={index} className="py-2 flex">
              <a href={`https://assets.locavibe.com.br/${path}`} className="text-bluePrimary" target="_blank">
                {path.split("/").reverse()[0]}
              </a>
            </span>
          ))}
        </div>
      </div>
    );
  });
